export default __webpack_public_path__ + "static/media/requestQuotation.aeeca20a.svg";